import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  getItem(item: string): any {
    var encodeData = localStorage.getItem(item);
    if (encodeData) {
      try {
        var decodeData = CryptoJS.AES.decrypt(encodeData, 'encoded data from dhadukWeb').toString(CryptoJS.enc.Utf8);
        return decodeData;
      } catch (error) {
        return null; // Return null if decryption fails
      }
    } else {
      return null;
    }
  }


  setData(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));  // Convert value to string
  }

  clear() {
    localStorage.clear();
  }


  deleteAllData(): void {
    localStorage.clear();
  }
  private tokenKey = 'auth_token';  // Key for storing token

  // Token management methods
  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  removeToken(): void {
    localStorage.removeItem(this.tokenKey);
  }


  getData(key: string): any {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;  // Parse stringified data
  }

  removeData(key: string): void {
    localStorage.removeItem(key);
  }
}
